import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`;
export const GET_RULES = `${SCOPE}/GET_RULES`;
export const SET_MODE = `${SCOPE}/SET_MODE`;
export const SET_CONFIG_SORTING = `${SCOPE}/SET_CONFIG_SORTING`;
export const CHANGE_WARNING_CONTAINER_VISIBILITY = `${SCOPE}/CHANGE_WARNING_CONTAINER_VISIBILITY`;
